import React from 'react';
import { useAppSelector } from '../store/hooks';

interface SuperuserProps {
  children?: React.ReactNode;
  className?: string;
}

// Renders its children only when the user is a superuser.
const Superuser = ({ children, className }: SuperuserProps) => {
  const isSuperuser = useAppSelector((store) => store.auth.isSuperuser);

  if (!isSuperuser) {
    return null;
  }

  return children instanceof Array
    ? <div className={className}>{children}</div>
    : <>{children}</>;
};

export default Superuser;
